import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export class StyleOne extends Component {
    render() {
        const { tag, serviceDesc, buttonText, bgcolor } = this.props
        return (
            <div className="col-6 col-md-3 rel-sev">
                <div className={"card full-card service-card " + bgcolor}>
                    <div className="column white-text">
                        <span className='text-uppercase'>{tag}</span>
                        <div className="card-body">
                            <p className="block-heading">{serviceDesc}</p>

                            <Link to="/" className="white-bordered-button-sm">{buttonText}</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export class StyleTwo extends Component {
    render() {
        const { tag, serviceDesc, buttonText, bgcolor } = this.props
        return (
            <div className="col-6 col-md-3 rel-sev">
                <div className={"card more-half-card service-card " + bgcolor}>
                    <div className="column white-text">
                        <span className='text-uppercase'>{tag}</span>
                        <div className="card-body turquoise-bg">
                            <p className="block-heading">{serviceDesc}</p>

                            <Link to="/" className="white-button-sm">{buttonText}</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}